/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VaultFastAccessView } from '../../models/vault-fast-access-view';

export interface FastAccessViewGetVaultFastAccessView$Params {
  vaultId: string;
}

export function fastAccessViewGetVaultFastAccessView(http: HttpClient, rootUrl: string, params: FastAccessViewGetVaultFastAccessView$Params, context?: HttpContext): Observable<StrictHttpResponse<VaultFastAccessView>> {
  const rb = new RequestBuilder(rootUrl, fastAccessViewGetVaultFastAccessView.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VaultFastAccessView>;
    })
  );
}

fastAccessViewGetVaultFastAccessView.PATH = '/fast-access-view/vault/{vaultId}';
